import { navigate, Router } from '@reach/router';
import React, { useContext, useEffect } from 'react';
import AuthLayout from '../../../components/auth-layout';
import { useTranslation } from '../../../hooks/useTranslation';
import Helmet from 'react-helmet';
import ROUTES from '../../../routes';
import Backdrop from '../../../components/backdrop';
import useContentMgmt from '../../../hooks/useContentMgmt';
import microcopyGroupIds from '../../../components/pge-plus-common/microcopyGroupIds';
import NavPaneWithInvoicePAymentSignIn from '../../../components/nav-pane/NavPanWithInvoicePaymentSignIn';
import useInvoiceGuestPayForm, { IneligibilityReason } from '../../../components/invoice-payment-portal/guest-pay/useInvoiceGuestPayForm';
import GuestPaymentForm from '../../../components/invoice-payment-portal/guest-pay/guest-payment-form';
import GuestPayConfirmation from '../../../components/invoice-payment-portal/guest-pay/guest-pay-confirmation';
import GuestPayTransactionSuccessful from '../../../components/invoice-payment-portal/guest-pay/guest-pay-transaction-successful';
import PrivateRoute from '../../../components/routing/PrivateRoute';
import NotFoundPage from '../../404';
import { NotificationsContext } from '../../../providers/NotificationsProvider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export const InvoicePaymentGuestPay = () => {
  const { t } = useTranslation();
  const { content } = useContentMgmt(
    microcopyGroupIds.INVOICE_PAYMENT_GUEST_PAY,
  );

  const props = useInvoiceGuestPayForm();
  const notificationContext = useContext(NotificationsContext);
 useEffect(() => {    
  const isTokenError =
        !props?.eligibility.isEligible &&
        (props?.eligibility.ineligibilityReason === IneligibilityReason.NoToken ||
          props?.eligibility.ineligibilityReason ===
            IneligibilityReason.NoInvoiceFound);
  
      if (isTokenError) {
        notificationContext.setState({
          isOpen: true,
          message: isTokenError
            ? props?.eligibility.ineligibilityReason ===
              IneligibilityReason.NoInvoiceFound
              ? t('NO_INVOICE_ERROR')
              : t('NO_TOKEN_ERROR')
            : t('GENERIC_ERROR_NOTIFICATION_MESSAGE_BODY'),
          severity: 'error',
        });
      } 
    }, [
      props?.eligibility?.isEligible,
      props?.eligibility?.ineligibilityReason
    ]);
  
    if (props?.invoiceLoading || !props?.eligibility.isEligible) {
      if (
        props?.eligibility.ineligibilityReason === IneligibilityReason.Other ||
        props?.eligibility.ineligibilityReason === IneligibilityReason.NoToken ||
        props?.eligibility.ineligibilityReason === IneligibilityReason.NoInvoiceFound
      ) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        navigate(ROUTES.INVOICE_PAYMENT_PORTAL_SIGN_IN);
      }
  
      return <Backdrop forceOpen />;
    }

  const isBrowser = !(typeof window === 'undefined');
 if(!isBrowser) {return null};
  return (
       
      <AuthLayout footer={' '} sideNav={<NavPaneWithInvoicePAymentSignIn />}>
        <Helmet>
          <title>{content.get('INVOICE_PAYMNET_GUEST_PAY')}</title>
        </Helmet>
      <Grid item xs={12}>
        <Typography variant={'h1'}>{content.get('INVOICE_PAYMNET_GUEST_PAY')}</Typography>
      </Grid>
     
        <Router>
        <GuestPaymentForm
            path={ROUTES.INVOICE_PAYMENT_GUEST_PAY}
            guestPaymentForm={props.guestPaymentForm}
            guestPaymentAccount={props.guestPaymentAccount!}
            handleOnGuestPayNext={props.handleOnGuestPayNext}            
            handleOnSaveProfile={props.handleOnSaveProfile}
            paymentDate={props.paymentDate}
            handleOnGuestPayCancel={props.clearGuestPaymentData}
            content={content}
          />
                    
          <GuestPayConfirmation
            path={ROUTES.INVOICE_PAYMENT_GUEST_PAY_PAYMENT_CONFIRMATION}
            guestPaymentAccount={props.guestPaymentAccount}
            guestPaymentForm={props.guestPaymentForm}
            paymentDate={props.paymentDate}
            handleOnSubmit={props.handleOnGuestPaymentSubmit}
            isInFlight={props.isInFlight}
            handleOnCancel={props.handleOnGuestPayCancelFromVerification}
            guestPaymentAuthForm={props.guestPaymentAuthForm}
          />
          <GuestPayTransactionSuccessful
            path={ROUTES.INVOICE_PAYMENT_GUEST_PAY_PAYMENT_SUCCESS}
            isSuccessful={props.transactionResults.isSuccessful}
            amount={props.transactionResults.amount}
            confirmationNumber={props.transactionResults.confirmationNumber}
            notificationContactValue={
              props.transactionResults.notificationContactValue
            }
            handleDoneClick={props.handleDoneClick}
            paymentFee={props.transactionResults?.paymentFee?.toString()!}
            invoiceId={props.transactionResults?.invoiceId}
          />
          <PrivateRoute path="/*" component={NotFoundPage} /> 
        </Router>
      </AuthLayout>
    
  );
};

export default InvoicePaymentGuestPay;
